<script lang="ts" setup>
import { Button } from '@collector/shared-ui'
import { useEventClock } from '@desktop/views/Relation/Sports/composables'

// composables
const { updateEventClockRunning, isClockRunning } = useEventClock()
</script>

<template>
  <Button
    :icon="isClockRunning ? 'pause' : 'play'"
    data-testid="event-clock-button"
    @click="updateEventClockRunning"
  />
</template>
